import { render, staticRenderFns } from "./vue-video-player.vue?vue&type=template&id=7e8711b6&"
import script from "./vue-video-player.vue?vue&type=script&lang=js&"
export * from "./vue-video-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports